import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

export function initCustomerIO(id: string, email: string) {
  const cioanalytics = AnalyticsBrowser.load(
    {
      writeKey: import.meta.env.VITE_CUSTOMERIO_API_KEY,
    },
    {
      integrations: {
        "Customer.io In-App Plugin": {
          siteId: import.meta.env.VITE_CUSTOMERIO_SITE_ID,
        },
      },
    },
  );

  cioanalytics.identify(id, { email });
}
